import * as React from 'react';
import { SVGProps } from 'react';
export const FileCheckIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={41}
    fill="none"
    {...props}
  >
    <path
      stroke="#18191C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M18.333 35.308H6.667A1.667 1.667 0 0 1 5 33.641V16.975a1.666 1.666 0 0 1 1.667-1.667H15l3.333 3.333h15A1.666 1.666 0 0 1 35 20.308v1.667M25 31.975l3.333 3.333L35 28.642"
    />
    <path
      stroke="#18191C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M28.333 5.308H10a1.667 1.667 0 0 0-1.667 1.667v8.333H15l3.333 3.333h13.334v-10l-3.334-3.333Zm0 0v3.333h3.334l-3.334-3.333Z"
    />
  </svg>
);
